import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-1857">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-1858">
        <img src="https://cdn.magicpatterns.com/uploads/3jKRGdDYYyuJjCRsZ6dRUg/fasstwire.png" alt="Fast Wire EDM Logo" className="h-16 md:h-20 w-auto mx-auto block" data-id="element-1859" />
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight" data-id="element-1860">
          Fast Wire EDM (Moly)
        </h1>
        <p className="text-xl text-white font-medium" data-id="element-1861">
          High-Speed Wire Cutting for 3D Metal Printing & Difficult Flush
          Conditions
        </p>
      </div>
    </div>;
}